/* import __COLOCATED_TEMPLATE__ from './jp-smirf-server-error.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();